import * as React from 'react';

/* @jsxImportSource @emotion/react */  import { css, jsx } from '@emotion/react'; /* eslint-disable-line */

const componentCss = css`

	--siteMenuSpacing: 32px;

	h2,h3,h4 {
		font-weight: normal;
	}

	.megamenu {

		.megamenu-icon-img {

			margin: 10px;

			img {
				height: 30px;
				display: block;
				margin: auto;
			}
		}

		.megamenu-icon i {
				margin: 13px;
				font-size: 24px;
				display: block;
				text-align: center;
		}

		.megamenu-icon svg {
				margin: 13px;
				font-size: 24px;
				display: block;
				text-align: center;
		}

		.logo-wrapper {
			display: table;
			width: 50px;
			height: 50px;
			min-width: 50px;
			min-height: 50px;
			margin-right: 20px;
			align-items: center;
			background-color: #dfe1e5;
			border-radius: 3px;
		}
		
		li {
			margin-bottom: 0;
			position: relative;

			a {
				position: relative;
				display: inline-block;
				padding-top: 16px;
				padding-bottom: 0px;
				
				color: #42526e;
				font-size: 1rem;
				vertical-align: middle;
			}
		}

		li:last-child {
			padding-bottom: 8px;
		}

		li.hr::before {
			border-top: .5px solid #c1c7d0;
			position: absolute;
			width: 30%;
			height: 1px;
			top: 0;
			left: 0;
			content: "";
		}

		h3 {
			color: #42526e;
			font-size: .75rem;
			line-height: 18px;
			letter-spacing: 1px;
			margin-top: 16px;
			text-transform: uppercase;

			&::after {
				background-color: #f4f5f7;
				border-radius: 1px;
				content: "";
				display: block;
				height: 2px;
				width: 68px;
			}
		}
	}

	.megamenu-columns {
		background-color: #fff;
		display: flex;
	}

	.megamenu-link {
		margin-top: 15px;
		display: flex;
		align-items: center;
	}

	.megamenu-link h4 {
		color: #091e42;
		font-size: 1rem;
		line-height: 20px;
		margin-bottom: 0;
		letter-spacing: .3px;
		font-weight: normal;
	}

	.megamenu-link .link-subtext {
		font-size: .75rem;
	}

	.megamenu-link .link-subtext, .megamenu-link .subtext--large {
		color: #42526e;
		line-height: 16px;
		margin-bottom: 0;
	}

	.primary-columns {
		padding-bottom: 100px;
		background-color: #fff;
		float: left;
		overflow: auto;
		padding-left: var(--siteMenuSpacing);
		padding-top: var(--siteMenuSpacing);
		padding-bottom: var(--siteMenuSpacing);

		.horizontal-align-padding-top {
			padding-top: 29px;
		}
	}

	.columns-1 {
		width: 250px;
	}

	.columns-2 {
		display: flex;
		
		.primary-column {
			width: 50%;
		}

		width: 500px;
	}

	.columns-3 {
		display: flex;
		
		.primary-column {
			width: 33%;
		}
	}
	
	.primary-column {
		float: left;
		padding: 0 20px 0 0;
	}

	ul {
		padding: 0;
		list-style: none;
	}

	.secondary-columns {
		width: 250px;
		padding: var(--siteMenuSpacing);
		background-color: #f4f5f7;
		
		li p {
			font-size: .75rem;
			line-height: 16px;
			margin-bottom: 0;
			max-width: 150px;
		}
	}

	h4 {
		margin: 0;
		font-weight: normal;
		letter-spacing: .3px;
		font-size: 1rem;
		line-height: 20px;
	}
	
	.grid-link-container {
		display: grid;
		grid-auto-columns: 1fr;
		grid-template-columns: 1fr 1fr;
		grid-template-rows: auto auto;
		grid-row-gap: 0px;
		grid-column-gap: 0px;
		grid-template-rows: auto auto auto auto;
		text-align: left;
	}

	.grid-link {
		min-width: 108px;
		margin-left: 0;
		font-size: 12px;
		font-weight: 400;
		position: relative;
		vertical-align: top;
		text-decoration: none;
		color: #222;
		padding: 4px;
		margin-top: 4px;
		text-align: left;
		white-space: nowrap;
		border-radius: 4px;
		background: #eee;
		padding: 12px;
		margin-right: 5px;
	}

	.grid-link-2 {
		min-width: 108px;
		margin-left: 0;
		font-size: 12px;
		font-weight: 400;
		position: relative;
		vertical-align: top;
		text-decoration: none;
		color: #222;
		padding: 4px;
		margin-top: 4px;
		text-align: left;
		white-space: nowrap;
		border-radius: 4px;
		background: #eee;
		padding: 12px;
		margin-right: 5px;
		grid-column: 1 / span 2;
	}

	.grid-link:hover {
		border-radius: 4px;
		background-color: #c1c7d0;
	}
	
	a {
		text-decoration: none !important;
	}
	
	a:hover {
		.logo-wrapper {
			background-color: #c1c7d0;
		}

		h4 {
			color: #0052cc !important;
		}
	}

	a:active, a:hover {
		outline: 0;
	}
	
	&.site-menu-section {
		--siteMenuSectionOffset: 0;
		display: inline-block;
		position: absolute;
		top: 50%;
		left: 0;
		transform: translateY(-50%) translateY(var(--siteMenuSectionOffset));
		transition: var(--siteMenuTransition);
		transition-property: transform, opacity;
		will-change: transform, opacity;
	}

	&.site-menu-section[hidden] {
		opacity: 0;
		pointer-events: none;
	}

	&.site-menu-section[hidden].site-menu-section--left {
		--siteMenuSectionOffset: -150px;
	}

	&.site-menu-section[hidden].site-menu-section--right {
		--siteMenuSectionOffset: 150px;
	}

	.site-menu-section {
		position: relative;
		display: inline-block;
	}

`;

export default React.forwardRef(({ selectedNav, index, children }, ref) => {

	return <div css={componentCss} ref={ref} className={"site-menu-section " + (selectedNav == 0 ? "" : selectedNav > index ? "site-menu-section--left" : "") + (selectedNav == 0 ? "" : selectedNav < index ? "site-menu-section--right" : "")} hidden={selectedNav !== index}>
		{children}
	</div>

});
